<template>
  <div class="c-app">
    <TheSideBar></TheSideBar>
    <CWrapper fluid>
      <TheHeader @logout="logout"></TheHeader>
      <loading :active.sync="isLoading"></loading>
      <div class="c-body">
        <main class="c-main">
          <transition name="fade" mode="out-in">
            <router-view @logout="logout"></router-view>
          </transition>
        </main>
      </div>
    </CWrapper>
    <b-modal
      v-model="showAutoLogoutModal"
      no-close-on-backdrop
      no-close-on-esc
      no-fade
      centered
      title="Keluar Otomatis"
      hide-header-close
      hide-footer
      scrollable
      size="sm"
    >
      <CRow>
        <CCol class="col-12 text-center">
          <p>Anda akan keluar secara otomatis dari aplikasi {{ autoLogout.currentTimer }} detik lagi</p>
        </CCol>
      </CRow>
      <CRow class="mt-2">
        <CCol class="col-12">
          <b-btn variant="primary" class="w-100" type="submit" @click="stayLogIn">
            Tetap Log In
          </b-btn>
        </CCol>
      </CRow>
    </b-modal>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState } from 'vuex';
import TheSideBar from './TheSidebar';
import TheHeader from './TheHeader';
export default {
    name: 'TheContainer',
    components: {
        Loading,
        TheHeader,
        TheSideBar
    },
    data(){
      return {
        window: window,

        windowFocused: true,

        showAutoLogoutModal: false,

        autoLogout: {

          settings: {
            timer: 600, // 10 menit (atau 600 detik)
            secondaryTimer: 15, // 15 detik
            trackInterval: 1000 // 1 detik
          },

          timerObject: undefined,

          currentTimer: -1,

          currentPointerX: -1,
          currentPointerY: -1,

          lastPointerX: -1,
          lastPointerY: -1,

          lastPointerSet: false,
        },
      }
    },
    methods: {
      logout(){

        // Clear Main timer objects
        this.clearTimerObject()

        // localStorage.removeItem(this.$tokenKeyword);
        this.$store.commit('set', ['token', ""]);
        // localStorage.removeItem(this.$tokenClockKeyword);
        this.$store.commit('set', ['tokenClock', ""]);
        // localStorage.removeItem(this.$userIdKeyword);
        this.$store.commit('set', ['userId', ""]);
        // localStorage.removeItem(this.$userNameKeyword);
        this.$store.commit('set', ['userName', ""]);
        // localStorage.removeItem(this.$roleIdKeyword);
        this.$store.commit('set', ['roleId', ""]);
        // localStorage.removeItem(this.$roleNameKeyword);
        localStorage.clear()
        sessionStorage.clear()

        window.removeEventListener('storage', this.dataReceived)

        this.$router.push({ name: 'Login' }).catch(()=>{})
      },
      resetTimer() {
        this.autoLogout.currentTimer = this.autoLogout.settings.timer
        // localStorage.setItem('fimsAction', 'logout')
        // localStorage.setItem('fimsResetTimer', 'true')
        this.$store.commit('set', ['fimsResetTimer', true]);
        // localStorage.setItem('fimsResetTimer', 'false')
        this.$store.commit('set', ['fimsResetTimer', false]);
      },
      initializeTimerObject() {
        this.autoLogout.timerObject = setInterval(this.trackPointerPosition, this.autoLogout.settings.trackInterval)
      },
      clearTimerObject() {
        clearInterval(this.autoLogout.timerObject)
      },

      trackPointerPosition() {
        if (this.autoLogout.lastPointerSet) {
          if (this.autoLogout.lastPointerX == this.autoLogout.currentPointerX && this.autoLogout.lastPointerY == this.autoLogout.currentPointerY) {
            // Mouse pointer didn't move
            if (this.autoLogout.currentTimer > this.autoLogout.settings.secondaryTimer) {
              // Timer is still more than 0
              if (this.showAutoLogoutModal) {
                this.showAutoLogoutModal = false
              }
              this.autoLogout.currentTimer--
              return
            } else if (this.autoLogout.currentTimer > 1) {
              // Timer is still more than the secondary timer
              if (!this.showAutoLogoutModal) {
                this.showAutoLogoutModal = true
              }
              this.autoLogout.currentTimer--
              return
            }

            // Logout!
            localStorage.setItem('fimsAction', 'logout')
            this.logout()

          } else{

            // Mouse pointer moved
            this.autoLogout.lastPointerX = this.autoLogout.currentPointerX
            this.autoLogout.lastPointerY = this.autoLogout.currentPointerY

            if (!this.showAutoLogoutModal) {
              // Auto Logout Modal not shown
              this.resetTimer()

            } else{

              // Auto Logout Modal shown
              if (this.autoLogout.currentTimer > 1) {
                // Timer counter is still more than 0
                // Timer countdown decrements
                this.autoLogout.currentTimer--
              } else{
                // Timer counter is 0

                // Logout!
                localStorage.setItem('fimsAction', 'logout')
                this.logout()
              }
            }
          }
        } else{
          this.autoLogout.lastPointerX = this.autoLogout.currentPointerX
          this.autoLogout.lastPointerY = this.autoLogout.currentPointerY
          this.autoLogout.lastPointerSet = true
        }
      },

      mousemove(event) {
        this.autoLogout.currentPointerX = event.clientX
        this.autoLogout.currentPointerY = event.clientY

        // Stop tracking once it detects mouse movement
        // It will be run again every second through runInterval() and startTracking method
        this.stopTracking()
      },

      startTracking(){
        document.addEventListener("mousemove", this.mousemove)
      },

      stopTracking(){
        document.removeEventListener("mousemove", this.mousemove)
      },

      runInterval(){
        this.startTracking()
      },

      stayLogIn() {

        this.showAutoLogoutModal = false

        // Load Main timer from setting and start it
        this.resetTimer()
        // this.initializeTimerObject()
      },

      dataReceived(event) {
        if (event.key == 'fimsAction') {
          let action = event.newValue
          if (!action) return // ignore empty action

          if (action == 'logout') this.logout()
        } else if (event.key == 'fimsResetTimer') {
          let reset = event.newValue
          if (reset == 'true') {
            this.autoLogout.currentTimer = this.autoLogout.settings.timer
            this.showAutoLogoutModal = false
          }
        }
      },
    },
    computed: mapState(['isLoading']),
    async created(){
      // VueX store
      let listStates = Object.keys(this.$store.state);
      await listStates.forEach((state) => {
        this.$store.commit('getStorage', state);
      });

      // Load Main timer from settings
      this.autoLogout.currentTimer = this.autoLogout.settings.timer

      // Start Main timer
      this.initializeTimerObject()

      // Start tracking mouse position
      setInterval(this.runInterval, this.autoLogout.settings.trackInterval)

      window.addEventListener('storage', this.dataReceived)
    },
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
